// src/components/guards.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authHeader, getAccess } from "../lib/auth";
import { isPunchHiddenForCurrentUser } from "../lib/punchAccess";
import HelpToggle from "./HelpToggle";
import ThemeSync from "./ThemeSync";

// 出退勤（打刻）画面を表示しない社員コード（S000/S001 等）は、
// 直接URLで来ても社員証表面へ戻す
export function PunchGuard({ children, redirectTo = "/card_front" }) {
  if (isPunchHiddenForCurrentUser()) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
}

function Loading() {
  return <div style={{ padding: 12 }}>Checking permission...</div>;
}

//
function getStoredAccess() {
  return localStorage.getItem("access") ?? sessionStorage.getItem("access") ?? null;
}
/*
export function AdminRoute({ children }) {
  const [ok, setOk] = React.useState(null);

  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const token = getStoredAccess();
        const res = await fetch("/api/auth/me/?_=" + Date.now(), { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) { if (alive) setOk(false); return; }
        const me = await res.json();
        //if (alive) setOk(!!(me?.is_staff || me?.is_superuser));
        if (alive) {
          const isStaff = me?.is_staff === true;
          const isSuper = me?.is_superuser === true;
          const perms = Array.isArray(me?.permissions) ? me.permissions : [];

          const hasAdminAccess = isStaff || isSuper || perms.length > 0;
          
          setOk(hasAdminAccess);
        }
      } catch { if (alive) setOk(false); }
    })();
    return () => { alive = false; };
  }, []);

  if (ok === null) return null;
  if (!ok) return <Navigate to="/admin/login" replace />;
  return <div className="admin-layout">{children}</div>;
}
*/
// src/components/guards.jsx
export function AdminRoute({ children }) {
  const [ok, setOk] = React.useState(null);

  React.useEffect(() => {
    const adminUserRaw = localStorage.getItem("adminUser");
    let alive = true;
    
    if (adminUserRaw) {
      try {
        const me = JSON.parse(adminUserRaw);
        
        const isStaff = me?.is_staff === true;
        const isSuper = me?.is_superuser === true;
        const perms = Array.isArray(me?.permissions) ? me.permissions : [];

        const hasAdminAccess = isStaff || isSuper || perms.length > 0;
        
        setOk(hasAdminAccess);
        return; 
      } catch (e) {
        console.error("adminUserエラーが発生しました:", e);
      }
    }

  
    (async () => {
      try {
        const token = getStoredAccess();
        if (!token) { if (alive) setOk(false); return; }
        
        const res = await fetch("/api/auth/me/?_=" + Date.now(), { 
          headers: { Authorization: `Bearer ${token}` } 
        });
        if (!res.ok) { if (alive) setOk(false); return; }
        
        const me = await res.json();
        if (alive) {
          const isStaff = me?.is_staff === true;
          const isSuper = me?.is_superuser === true;
          const perms = Array.isArray(me?.permissions) ? me.permissions : [];
          setOk(isStaff || isSuper || perms.length > 0);
        }
      } catch { 
        if (alive) setOk(false); 
      }
    })();

    return () => { alive = false; };
  }, []);

  if (ok === null) return null;
  if (!ok) return <Navigate to="/admin/login" replace />;
  

  return <div className="admin-layout">{children}</div>;
}

export function EmployeeRoute({ children, loginPath = "/m/login" }) {
  const access = getStoredAccess();
  if (!access) return <Navigate to={loginPath} replace />;
  // 全社員画面は EmployeeRoute で包まれているため、ここに1箇所置けば
  // 各画面（および今後追加される画面）に説明トグル・OSテーマ追従が自動で付く。
  // ThemeSync は管理画面には入らないので、管理側はライト固定のまま。
  return (
    <>
      {children}
      <HelpToggle />
      <ThemeSync />
    </>
  );
}
